// アプリの名前・説明の禁止ワード（プロフィールの名前と同じ一覧）。
// 公開すると他の子に見えるので、作る・コピーする・直すときに確かめる。api でも同じように確かめる
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { RootState } from "app/store";
import I18n from "common/i18n";

/** どれかに禁止ワードが入っていれば true */
export const useHasBannedWord = () => {
  const words = useSelector((state: RootState) => state.config.banned.words);
  return (...texts: (string | null | undefined)[]) =>
    texts.some((text) => !!text && words.some((word) => text.includes(word.word)));
};

export const warnBannedWord = () =>
  toast.warn(
    <div>
      <p className="type-text type-sm text-textcolor-black">
        {I18n.t("MSG_BUILDER_COMMENT_BANNED_WORD")}
      </p>
    </div>,
  );
